import { navigationStore } from '../../../app/stores/Navigation';
import { ScreenComponent } from '../../../models/enums/ScreenComponents';
import { TouchableHighlight } from 'react-native-gesture-handler';
import { Text } from 'react-native';
import { appConfigStore } from '../../../app/stores/AppConfig';
import { useScreenComponent } from '../../../app/hooks/custom/useScreenComponent';
import { useStoreConfig } from '../../../contexts/StoreConfigContext';

interface NavBarItem {
	screen: ScreenComponent;
}

export const NavBarItem = ({ screen }: NavBarItem) => {
	const { currentScreen, screenDisplayNames } = navigationStore((state) => state);
	const darkMode = appConfigStore((state) => state.darkMode);
	const isCurrentScreen = currentScreen === screen;
	const { navigateToScreen } = useScreenComponent();
	const { config } = useStoreConfig();

	// Use Google Font if set, otherwise use local font
	const primaryFontFamily = config.primaryFont || 'primaryFont';

	// Get display name from store, fallback to formatted screen key
	const displayName = screenDisplayNames[screen] || screen.replaceAll('_', ' ').toString();

	return (
		<TouchableHighlight
			style={{
				minHeight: 32,
				paddingHorizontal: 10,
				marginHorizontal: 12,
				paddingBottom: 4,
				justifyContent: 'center',
				borderBottomColor: isCurrentScreen ? config.primaryColor : 'transparent',
				borderBottomWidth: 3,
			}}
			underlayColor='transparent'
			onPress={() => {
				navigateToScreen(screen);
			}}
		>
			<Text
				style={{
					fontSize: 16,
					letterSpacing: 0.5,
					fontWeight: '900',
					fontFamily: primaryFontFamily,
					textAlign: 'center',
					color: darkMode ? 'white' : 'black',
				}}
			>
				{displayName}
			</Text>
		</TouchableHighlight>
	);
};
